import { useState, ReactNode } from 'react'

import './Group.scss'

import { GroupProps } from './types/GroupTypes'

const Group = ({ children, icon, label, isMenuOpen, closedPlaceholder, closedIcon, expandable, openMenu, customClasses }: GroupProps) => {
    const [isOpen, setIsOpen] = useState(true)

    const nothingToRender = !isMenuOpen && !closedIcon && !closedPlaceholder && !icon && expandable
    const showGroupIcon = !isMenuOpen && closedIcon
    const showGroupPlaceholder = !isMenuOpen && closedPlaceholder
    const showEntries = (isMenuOpen && isOpen) || !expandable

    const handleButtonClick = (): void => {
        if (!isMenuOpen) {
            openMenu()
            setIsOpen(true)
        }
        else
            setIsOpen(!isOpen)
    }

    const renderHeadline = (): ReactNode => {
        let headline: ReactNode = null

        if (label) {
            headline = (
                <div className='headline'>
                    {
                        (!isMenuOpen && icon) &&
                        <i className={`button-icon a-icon boschicon-bosch-ic-${icon}`} title={label}></i>
                    }
                    {
                        isMenuOpen &&
                        <span className='a-menu-item__label'>{label}</span>
                    }
                </div>
            )
        }

        return headline
    }

    const renderHeadlineButton = (): ReactNode => {
        let headlineButton: ReactNode = null

        switch (true) {
            case (showGroupPlaceholder): {
                headlineButton = closedPlaceholder
                break
            }
            case (!!showGroupIcon): {
                headlineButton = (
                    <button
                        onClick={handleButtonClick}
                        className='a-menu-item__link'
                        aria-disabled='false'
                    >
                        <i className={`a-icon boschicon-bosch-ic-${closedIcon}`}></i>
                    </button>
                )
                break
            }
            default: {
                headlineButton = (
                    <button
                        onClick={handleButtonClick}
                        className='a-menu-item__link'
                        aria-disabled='false'
                    >
                        {
                            (!isMenuOpen && icon) &&
                            <i className={`button-icon a-icon boschicon-bosch-ic-${icon}`} title={label}></i>
                        }
                        {
                            isMenuOpen &&
                            <>
                                <span className='a-menu-item__label'>{label}</span>
                                <i className={`a-icon ui-ic-down-small ${isOpen ? 'collapse-icon' : ''}`}></i>
                            </>
                        }
                    </button>
                )
                break
            }
        }

        return headlineButton
    }

    if (nothingToRender) return null

    const isLiOpen = !expandable || isOpen

    return (
        <li className={`navigation-group a-menu-item ${isLiOpen ? '-open' : ''} ${customClasses}`} role='none'>
            <div className='head a-menu-item__wrapper'>
                {expandable && renderHeadlineButton()}
                {!expandable && renderHeadline()}
            </div>
            {showEntries && (
                <ul className='m-menu-group__group' role='menu'> {/* if custom class is "scrollable" this gets a scrollbar */}
                    {children}
                </ul>
            )}
        </li>
    )
}

export default Group
